define('components/charts/loaders/cashflow_history_chart',[
    'components/charts/common',
    'components/charts/tooltip',
    'components/strings',
    'google_charts!corechart'
], function(common, tooltip, stringsComponent) {
    var POINT_SIZE = 6;
    var MAX_TICKS = 12,
        DEFAULT_FONT_SIZE = 12,
        DEFAULT_FONT_NAME = 'Arial';

    var loader = function($container) {
        var data = parseData($container);
        var contributionLabelOverride = $container.data('contribution-label');
        var chart = new google.visualization.AreaChart($container[0]);
        var chartOptions = determineChartOptions(data);
        var datatable = createDataTable(data, chartOptions, contributionLabelOverride);
        registerTooltip($container, chart, data, datatable);

        if (!data.hidePoints) {
            var readyHandler = google.visualization.events.addListener(chart, 'ready', function() {
                _computeOverlappingPoints(chart, data, datatable);
                google.visualization.events.removeListener(readyHandler);
            });
        }

        return {
            instance: chart,
            draw: function() {
                chart.draw(datatable, chartOptions);
            },
            shouldRedrawOnWindowResize: true,
            redraw: function() {
                chart.draw(datatable, chartOptions);
            }
        };
    };

    /**
    `json` should contain: {
        // Optional, default `False`
        hidePoints: False,

        // Optional, default `False`
        miniLayout: False,

        // Optional, default `True`.
        // Sets the right edge of the horizontal axis to the current date.
        scaleAxisToCurrentDate: True,

        // Optional, default `True`.
        // Hidden if "details_url" is blank.
        showDetailsLinkInTooltips: True,

        // Optional.
        fontSize: 10,

        // Optional.
        // Dates must be in ISO 8601 format (full datetime),
        // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
        // and http://stackoverflow.com/questions/3257460/new-date-is-working-in-chrome-but-not-firefox
        commitment_deltas: [
            {
                datetimeISO8601: '2000-12-25',
                amount: 999,
                label: 'abcd',
                details_url: ''
            }
        ],

        // Required.
        // Dates must be in ISO 8601 format (full datetime),
        // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
        // and http://stackoverflow.com/questions/3257460/new-date-is-working-in-chrome-but-not-firefox
        contributions: [
            {
                datetimeISO8601: '2000-12-25',
                amount: 999,
                label: 'abcd',
                details_url: ''
            }
        ],

        // Required.
        // Dates must be in ISO 8601 format (full datetime),
        // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
        // and http://stackoverflow.com/questions/3257460/new-date-is-working-in-chrome-but-not-firefox
        redemptions: [
            {
                datetimeISO8601: '2000-12-25',
                amount: 999,
                label: 'abcd',
                details_url: ''
            }
        ],

        // Required
        // Dates must be in ISO 8601 format (full datetime),
        // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
        // and http://stackoverflow.com/questions/3257460/new-date-is-working-in-chrome-but-not-firefox
        distributions: [
            {
                datetimeISO8601: '2000-12-25',
                amount: 999,
                label: 'abcd',
                details_url: ''
            }
        ]
    }
    **/
    function parseData($container) {
        // NOTE: `.data()` will automatically convert to a JS object.
        var data = $container.data('json');
        data._commitment_deltas = data.commitment_deltas || [];
        data._chronologicalTransactions = [].concat(convertISO8601Datetimes('commitment', data._commitment_deltas))
                                            .concat(convertISO8601Datetimes('contribution', data.contributions))
                                            .concat(convertISO8601Datetimes('redemption', data.redemptions))
                                            .concat(convertISO8601Datetimes('distribution', data.distributions));
        data._chronologicalTransactions.sort(function compareDateAsc(a, b) {
            return a.date - b.date;
        });
        data._seriesByName = {
            commitment: {
                order: 0,
                runningTotal: 0,
                pointsByDatetimeISO8601: {},
                sequence: []
            },
            contribution: {
                order: 1,
                runningTotal: 0,
                pointsByDatetimeISO8601: {},
                sequence: []
            },
            redemption: {
                order: 2,
                runningTotal: 0,
                pointsByDatetimeISO8601: {},
                sequence: []
            },
            distribution: {
                order: 3,
                runningTotal: 0,
                pointsByDatetimeISO8601: {},
                sequence: []
            },
        };
        data._chronologicalTransactions.forEach(function(x) {
            var seriesName = x.transactionType;
            var series = data._seriesByName[seriesName];
            series.runningTotal += x.amount;
            if (!series.pointsByDatetimeISO8601[x.datetimeISO8601]) {
                series.pointsByDatetimeISO8601[x.datetimeISO8601] = {
                    seriesName: seriesName,
                    date: x.date,
                    runningTotal: series.runningTotal,
                    transactions: [x]
                };
                series.sequence.push(series.pointsByDatetimeISO8601[x.datetimeISO8601]);
            } else {
                series.pointsByDatetimeISO8601[x.datetimeISO8601].runningTotal = series.runningTotal;
                series.pointsByDatetimeISO8601[x.datetimeISO8601].transactions.push(x);
            }
        });

        return data;
    }

    function convertISO8601Datetimes(transactionType, list) {
        if (!list) return [];
        return list.map(function(x) {
            return {
                transactionType: transactionType,
                date: new Date(x.datetimeISO8601),
                datetimeISO8601: x.datetimeISO8601,
                amount: x.amount,
                htmlEscapedLabel: stringsComponent.escapeHtml(x.label),
                details_url: x.details_url
            };
        });
    }

    function determineChartOptions(data) {
        var options = {
            legend: {
                position: data.miniLayout ? 'top' : 'right',
                textStyle: {
                    fontSize: data.fontSize || DEFAULT_FONT_SIZE,
                    fontName: data.fontName || DEFAULT_FONT_NAME,
                }
            },
            chartArea: {
                width: data.miniLayout ? '90%' : '75%',
                left: '50',
                top: '30',
            },
            vAxis: {
                baselineColor: data.axisColor || '#CCC',
                gridlines: {
                    color: '#CCC'
                },
                format: 'short',
                textStyle: {
                    color: data.axisColor || '#777777',
                    fontSize: data.fontSize || DEFAULT_FONT_SIZE,
                    fontName: data.fontName || DEFAULT_FONT_NAME,
              },
                viewWindow: {min:0}
            },
            hAxis: {
                slantedText: true,
                slantedTextAngle: 45,
                showTextEvery: 1,
                textStyle: {
                    color: data.axisColor || '#777777',
                    fontSize: data.fontSize || DEFAULT_FONT_SIZE,
                    fontName: data.fontName || DEFAULT_FONT_NAME,
                },
                baselineColor: data.axisColor || '#CCC',
                gridlines: {
                    color: 'transparent'
                }
            },
            enableInteractivity: false,

            series: {
                0: {
                    pointsVisible: !data.hidePoints,
                    pointSize: POINT_SIZE,
                    areaOpacity: 0,
                    lineWidth: 2,
                    lineDashStyle: [8, 2],
                    color: common.colors.commitment,
                    visibleInLegend: data._commitment_deltas.length > 0
                },
                1: {
                    pointsVisible: !data.hidePoints,
                    pointSize: POINT_SIZE,
                    color: common.colors.contribution,
                    lineWidth: 3,
                    areaOpacity: 0.3,
                    visibleInLegend: data.contributions.length > 0
                },
                2: {
                    pointsVisible: !data.hidePoints,
                    pointSize: POINT_SIZE,
                    color: common.colors.redemption,
                    lineWidth: 3,
                    areaOpacity: 0.3,
                    visibleInLegend: data.redemptions.length > 0
                },
                3: {
                    pointsVisible: !data.hidePoints,
                    pointSize: POINT_SIZE,
                    color: common.colors.distribution,
                    lineWidth: 3,
                    areaOpacity: 0.3,
                    visibleInLegend: data.distributions.length > 0
                }
            }
        };

        options.hAxis.ticks = getTicks(data);

        if (data._chronologicalTransactions.length > 0) {
            options.hAxis.viewWindow = {min: getMinDate(data), max: getMaxDate(data)};
        }

        return options;
    }

    function getMaxDate(data) {
        if (data._chronologicalTransactions.length == 0) return null;
        var maxTransactionDate = data._chronologicalTransactions[data._chronologicalTransactions.length - 1].date;
        var today = new Date();
        if (data.scaleAxisToCurrentDate && maxTransactionDate < today) {
            return today;
        }
        return maxTransactionDate;
    }

    function getMinDate(data) {
        if (data._chronologicalTransactions.length == 0) return null;
        return data._chronologicalTransactions[0].date;
    }

    function getTicks(data) {
        var ticks = [];
        var firstQuarterAndYear = getCalendarQuarterAndYear(getMinDate(data));
        var lastQuarterAndYear = getCalendarQuarterAndYear(getMaxDate(data));

        // Use default default ticks if there we're just showing a single quarter.
        if (firstQuarterAndYear && lastQuarterAndYear && firstQuarterAndYear.year == lastQuarterAndYear.year
                                                      && firstQuarterAndYear.quarter == lastQuarterAndYear.quarter) {
            return null;
        }

        if (firstQuarterAndYear) {
            var currentYear = firstQuarterAndYear.year;
            var currentQuarter = firstQuarterAndYear.quarter;
            while (currentYear <= lastQuarterAndYear.year) {
                do {
                    ticks.push({
                        v: new Date(currentYear, getMonthForQuarter(currentQuarter), 1),
                        f: formatQuarterAndYear({quarter:currentQuarter, year:currentYear})
                    });
                    currentQuarter++;
                } while (currentYear < lastQuarterAndYear.year ? currentQuarter <= 4 : currentQuarter <= lastQuarterAndYear.quarter);
                currentQuarter = 1;
                currentYear++;
            }
        }

        if (ticks.length > MAX_TICKS) {
            var stepSize = Math.floor(ticks.length / MAX_TICKS);
            var reducedTicks = [];
            ticks.forEach(function(tick, i) {
                if (i % stepSize == 0) reducedTicks.push(tick);
            });
            return reducedTicks;
        }

        return ticks; 
    }

    function getCalendarQuarterAndYear(date) {
        if (!date) return null;
        var month = date.getUTCMonth() + 1;
        var quarter = Math.ceil(month / 3);
        return {
            year: date.getUTCFullYear(),
            quarter: quarter
        };
    }

    function formatQuarterAndYear(d) {
        var q = 'Q' + d.quarter;
        var yy = ('' + d.year).substring(2);
        return q + "'" + yy;
    }

    function getMonthForQuarter(quarter) {
        return (quarter - 1)*3;
    }

    var SERIES_BY_COLUMN = {
        1: 0, // Commitment
        3: 1, // Contribution
        5: 2, // Redemption
        7: 3, // Distribution
    };
    function createDataTable(data, chartOptions, contributionLabelOverride) {
        // NOTE: Keep the column indices consistent with SERIES_BY_COLUMN
        var datatable = new google.visualization.DataTable();
        datatable.addColumn({type:'date', label:'Quarter'});
        datatable.addColumn({type:'number', label:'Commitment'});
        datatable.addColumn({type:'string', role:'style'});
        datatable.addColumn({type:'number', label:contributionLabelOverride ||
            (data.use_contributions_label ? 'Contributions' : 'Capital In')});
        datatable.addColumn({type:'string', role:'style'});
        datatable.addColumn({type:'number', label:'Capital Out'});
        datatable.addColumn({type:'string', role:'style'});
        datatable.addColumn({type:'number', label:'Distributions'});
        datatable.addColumn({type:'string', role:'style'});

        addRows(datatable, data, 'commitment', 1, 2);
        addRows(datatable, data, 'contribution', 3, 4);
        addRows(datatable, data, 'redemption', 5, 6);
        addRows(datatable, data, 'distribution', 7, 8);

        return datatable;
    }

    function addRows(datatable, data, seriesName, amountColumn, styleColumn) {
        var style = data.hidePoints ? '' : 'point { fill-color:' + common.colors[seriesName] + '; shape-type:circle; size:'+ POINT_SIZE +' }';

        var maxDate = getMaxDate(data);

        var lastEntry = null;
        datatable.addRows(data._seriesByName[seriesName].sequence.map(function(x, i) {
            lastEntry = x;
            var row = [{v:x.date, p:{point:x}}];

            // Let the array autogrow to the correct length.
            row[datatable.getNumberOfColumns() - 1] = null;

            row[amountColumn] = x.runningTotal;
            row[styleColumn] = style;
            return row;
        }));

        if (lastEntry && lastEntry.date < maxDate) {
            var row = [maxDate];
            // Let the array autogrow to the correct length.
            row[datatable.getNumberOfColumns() - 1] = null;

            row[amountColumn] = lastEntry.runningTotal;
            row[styleColumn] = 'point { size:0 }';
            datatable.addRow(row);
        }
    }

    function registerTooltip($container, chart, data, datatable) {
        if (data.hidePoints) return;

        tooltip.setTooltipHandler(chart, {
            onlyHoverOnDataPoints: true,
            handler: function(row, column) {
                var layout = chart.getChartLayoutInterface();
                var series = SERIES_BY_COLUMN[column];
                var bbox = layout.getBoundingBox('point#' + series + '#' + row);
                var hoveredPoint = datatable.getProperty(row, 0, 'point')
                if (!bbox || !hoveredPoint) return;

                var tooltipBodies = [];
                [hoveredPoint].concat(hoveredPoint.overlappingPoints).forEach(function(point) {
                    // Use the real bounding box, which may have changed slightly due to window resizing.
                    var box = layout.getBoundingBox(point.boxId);
                    bbox.left = Math.min(bbox.left, box.left);
                    bbox.top = Math.min(bbox.top, box.top);
                    bbox.right = Math.max(bbox.right || 0, box.left + box.width);
                    bbox.bottom = Math.max(bbox.bottom || 0, box.top + box.height);
                    
                    if (point.seriesName == 'commitment') {
                        var seriesNamePlural = 'Commitment';
                        var seriesNameCapitalized = 'Commitment';
                    } else if (point.seriesName == 'contribution') {
                        var seriesNamePlural = 'Capital In';
                        var seriesNameCapitalized = 'Capital In';
                    } else if (point.seriesName == 'redemption') {
                        var seriesNamePlural = 'Capital Out';
                        var seriesNameCapitalized = 'Capital Out';
                    } else if (point.seriesName == 'distribution') {
                        var seriesNamePlural = 'Distributions';
                        var seriesNameCapitalized = 'Distribution';
                    }
                    var transactionsRows = point.transactions.reduce(function(rows, x, i) {
                        var thTitleClass = i > 0 ? 'text-center border-top padding-top' : 'text-center';
                        var label = x.htmlEscapedLabel;
                        if (data.showDetailsLinkInTooltips && x.details_url) {
                            label = '<a href="' + x.details_url + '">' + x.htmlEscapedLabel + '</a>';
                        }
                        return rows.concat([
                            '<tr><th class="' + thTitleClass + '" colspan="2"><em>'+ label +'</em></th></tr>',
                            '<tr><th class="text-right">' + common.mediumDateFormat.formatValue(point.date) + '</th><td class="text-left">' + common.formatCurrency(x.amount, data.currency) + '</td></tr>'
                        ]);
                    }, []);

                    tooltipBodies.push({
                        date: point.date,
                        order: data._seriesByName[point.seriesName].order,
                        html: '<table class="alignment_table">' + transactionsRows.join('') +
                            '<tr><th class="text-right border-top padding-top" style="white-space:nowrap">' + seriesNamePlural + ' as of ' + common.mediumDateFormat.formatValue(point.date) + '</th><td class="text-left border-top padding-top">' + common.formatCurrency(point.runningTotal, data.currency) + '</td></tr>' +
                            '</table>'
                    });
                });
                bbox.width = bbox.right - bbox.left;
                bbox.height = bbox.bottom - bbox.top;

                tooltipBodies.sort(function descendingByDateAndSeries(a, b) {
                    if (a.date < b.date) return 1;
                    if (a.date > b.date) return -1;
                    if (a.order < b.order) return 1;
                    if (a.order > b.order) return -1;
                    return 0;
                });
                
                var offset = $container.offset();

                return {
                    title: '',
                    body: tooltipBodies.map(function(body) { return body.html }).join('<br/>'),
                    targetX: offset.left + bbox.left + bbox.width/2,
                    targetY: offset.top + bbox.top
                };
            }
        });
    }

    function _computeOverlappingPoints(chart, data, datatable) {
        var layout = chart.getChartLayoutInterface();
        var points = [];
        for (var series = 0; series <= 3; series++) {
            for (var row = 0, nRows = datatable.getNumberOfRows(); row < nRows; row++) {
                var boxId = 'point#' + series + '#' + row;
                var bbox = layout.getBoundingBox(boxId);
                var point = datatable.getProperty(row, 0, 'point');
                if (bbox && point) {
                    point.boxId = boxId;
                    point.box = bbox;
                    points.push(point);
                }
            }
        }
        points.forEach(function(point1) {
            point1.overlappingPoints = [];
            points.forEach(function(point2) {
                if (point2 === point1) return;
                if (_overlaps(point1.box, point2.box)) {
                    point1.overlappingPoints.push(point2);
                }
            });
        });
    }

    function _overlaps(box1, box2) {
        return _inside(box1.left, box1.top, box2) ||
               _inside(box1.left + box1.width, box1.top, box2) ||
               _inside(box1.left + box1.width, box1.top + box1.height, box2) ||
               _inside(box1.left, box1.top + box1.height, box2) ||
               _inside(box2.left, box2.top, box1) ||
               _inside(box2.left + box2.width, box2.top, box1) ||
               _inside(box2.left + box2.width, box2.top + box2.height, box1) ||
               _inside(box2.left, box2.top + box2.height, box1);
    }

    function _inside(x, y, bounds) {
        return x >= bounds.left && x <= bounds.left + bounds.width &&
               y >= bounds.top && y <= bounds.top + bounds.height;
    }

    return loader;
});


